import { clickClient, DomainType } from "@/lib/request";
import { UNPL_DATA } from "@/pages/distribution-center/hooks/constants";
import { ssrFetch } from "@/lib/ssrFetch";

/**
 * unpl相关API路径
 */
const UNPL_API_PATHS = {
  // 点击接口
  CLICK_UNPL: '/cps/clickReferralLink',
} as const;

export interface UnplParams {
  p: string;
  t: string;
  c: string;
  utrans?: string;
  sessionId?: string;
  referrer: string;
  externalExp?: string | number;
  externalStrategy?: string | number;
  uuid?: string | number;
}

export interface UnplResponse {
  unpl: string;
  landingPageUrl: string;
  setLandingPageUrl: string;
  setUnpl: boolean;
}


interface RequestUnplWithSessionParams {
  session: string;
  unpl: string;
}


/**
 * 获取 UNPL
 * @param params - 请求参数
 * @returns
 */
export async function getUnpl(params: UnplParams) {
  return clickClient.post<UnplParams, UnplResponse>({
    url: UNPL_API_PATHS.CLICK_UNPL,
    data: params
  });
}

/**
 * unpl和sessionid绑定
 * @param params unpl和sessionid
 * @returns
 */
export async function requestUnplWithSessionId(params: RequestUnplWithSessionParams) {
  return clickClient.post<RequestUnplWithSessionParams, any>({
    url: "/cps/clickReferralLink/session",
    data: params
  });
}

/**
 * =====================================================
 * SSR兼容函数
 * =====================================================
 */

/**
 * SSR环境获取unpl
 * 与CSR完全一致的API设计：只接收一个业务参数
 * @param requestParams 请求参数（包含commonParams和业务参数）
 * @returns 获取unpl完整响应
 */
export async function getUnplForSSR(
  requestParams: UnplParams,
  headers: {
    Referer: string,
    "user-agent": string
  }
): Promise<string> {
  const response = await ssrFetch.post<UnplResponse, UnplParams>(
    DomainType.CLICK,
    UNPL_API_PATHS.CLICK_UNPL,
    requestParams,
    { headers }
  );

  // 返回完整响应结构,与CSR保持一致
  return response?.data?.unpl || UNPL_DATA;
}
